import {
  bioFilter,
  geoLocationFilter,
  hasPastDueSubscriptionFilter,
  headlineFilter,
  invitationLinkIdsFilter,
  levelFilter,
  locationFilter,
  nameFilter,
  onlineStatusFilter,
  paywallsFilter,
  roleFilter,
  tagsFilter,
} from "../../../SettingsApp/ManageMembers/TabContent/Filters/filterConfiguration";

export const membersSpaceFilters = [
  nameFilter,
  bioFilter,
  headlineFilter,
  locationFilter,
  geoLocationFilter,
  roleFilter,
  invitationLinkIdsFilter,
  onlineStatusFilter,
  tagsFilter,
  paywallsFilter,
  hasPastDueSubscriptionFilter,
  levelFilter,
];
